module.exports = __webpack_public_path__ + "img/logo.e4e84bd1.png";